module.exports = __webpack_public_path__ + "static/media/kappa.600eede5.png";